import styled from 'styled-components'

import { helpers } from 'styles'

export const Subtitle = styled.span`
	display: flex;
	column-gap: 6px;
	align-items: center;
	color: ${helpers.color.textMuted};
	font-size: ${helpers.font.size.small};
	margin-bottom: 4px;
	overflow-wrap: anywhere;
	max-width: max-content;
`
